import { useFormContext } from 'react-hook-form';
import { UnitListSchemaType } from '../PropertySettingsUnitsTab.schema';
import { AddExtraUnits } from './AddExtraUnits';
import { UnitListContainer } from './UnitList.styles';
import NoUnitsFound from './NoUnitsFound';
import UnitListItem from './UnitListItem';

const UnitList = () => {
  const { watch } = useFormContext<UnitListSchemaType>();

  const units = watch('units') ?? [];

  return units.length > 0 ? (
    <UnitListContainer key={units.length}>
      {units.map((unit, index) => (
        <UnitListItem key={unit.uid} unit={unit} index={index} />
      ))}

      <AddExtraUnits />
    </UnitListContainer>
  ) : (
    <NoUnitsFound />
  );
};

export default UnitList;
